import axios from "axios";

export interface CheckUserData {
  phone?: string;
  email?: string;
}

export const checkUserService = async (variables: CheckUserData): Promise<boolean> => {
  try {

    const { phone, email } = variables;

    const filter = phone !== undefined ? 'phone' : 'email';
    const value = phone ?? email;

    if (!value) throw new Error('No phone or email provided');

    const response = await axios.post(`/users/find-by-${filter}`, { value });

    if(!response.data.isOk) throw new Error(response.data.message);

    return response.data.isOk;
  } catch (error: any) {
    console.log('error in cactch service ', error);
    throw new Error(error.message);
  }
};
